import axios from "axios";

export const api = axios.create({
  baseURL: "/api",
  timeout: 12000
});

export async function submitLead(type, payload) {
  const { data } = await api.post(`/leads/${type}`, payload);
  return data;
}

export async function createDownloadLead(payload) {
  const { data } = await api.post("/downloads", payload);
  return data;
}

export async function askAssistant(question) {
  const { data } = await api.post("/assistant/search", { question });
  return data;
}
export async function getDashboardStats() {
  const response = await fetch("/api/admin/stats");

  if (!response.ok) {
    throw new Error("Unable to load dashboard statistics.");
  }

  return response.json();
}